module.exports = __webpack_public_path__ + "static/media/060.0e7ee592.jpg";